import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { CatalogGrade } from "@/shared/models/CatalogGrade";
import { ColDef, ICellRendererParams } from "ag-grid-community";

type Props = {
	setSelectedRowData: (grade: CatalogGrade) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "GradeName",
			headerName: "Name",
			flex: 2,
			minWidth: 150,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as CatalogGrade,
				edit: true,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "gradesContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 220,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	const getMenuOptions = (data: CatalogGrade) => {
		let options: MenuOptionType[] = [];

		options = options.concat([
			{
				name: "New Grade",
				key: "new_grade",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);

		if (data) {
			options = options.concat([
				{
					name: "Edit Grade",
					key: "edit_grade",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Grade",
					key: "delete_grade",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}

		return options;
	};

	return { columnDefs, getMenuOptions };
};
